//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stars from '@/common/tpl/value_analysis/_stars'
import { App_User } from '@/data/user_info'
export default {
    props: {
        general_ratings: Object,
        is_consultant: Boolean
    },
    components: {
        Stars
    },
    computed: {
        formatScore () {
            return (value) => {
                let score = parseInt(value)
                if (score >= 5 && score < 7) {
                    return 4
                } else if (score >= 7 && score < 8) {
                    return 4.5
                } else if (score >= 8) {
                    return 5
                }
                return 3                
            }
        }
    },
    methods: {
        goTo () {
            App_User.get().then((data) => {
                if (data.tag_list && data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                } else {
                    const { building_id } = this.$route.query
                    wx.navigateTo({
                        url: `/building/value_analysis/main?building_id=${building_id}`
                    })
                }
            })
        }
    }
}
